import { render, staticRenderFns } from "./BaseInlineSwitch.vue?vue&type=template&id=54a4ebfe&scoped=true"
import script from "./BaseInlineSwitch.vue?vue&type=script&lang=ts"
export * from "./BaseInlineSwitch.vue?vue&type=script&lang=ts"
import style0 from "./BaseInlineSwitch.vue?vue&type=style&index=0&id=54a4ebfe&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54a4ebfe",
  null
  
)

export default component.exports